import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "./jwt.service";
import { NEW_API_URL } from "../common/config-local";

const ApiService = {
  init() {
    axios.defaults.baseURL = NEW_API_URL
    axios.defaults.withCredentials = true
    Vue.use(VueAxios, axios);
    this.setHeader();
    this.setupInterceptors();
  },

  setupInterceptors() {
    Vue.axios.interceptors.request.use(
      (config) => {
        this.setHeader();
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    Vue.axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          // Gérer ici les cas d'erreur d'authentification ou les jetons expirés
          // Rediriger l'utilisateur vers la page de connexion par exemple
        }
        return Promise.reject(error);
      }
    );
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  get(resource, params, extra = {}) {
    var qs = require('qs');
    return Vue.axios.get(resource, {
      params: params,
      withCredentials: true,
      paramsSerializer: params => {
        return qs.stringify(params,{ skipNulls: true })
      },
      ...extra
    })
  },

  post(resource, params) {
    return Vue.axios.post(resource, params, {withCredentials:true});
  },

  put(resource, params) {
    return Vue.axios.put(resource, params, { withCredentials: true});
  },

  delete(resource) {
    return Vue.axios.delete(resource, { withCredentials: true})
  }
};

export default ApiService;
